import { useContext } from "react";
import Page from "../layout/Page";
import { Grid, Typography } from "@mui/material";
import { UserContext } from '../App'

export default function HomePage(props = {}) {
  const user = useContext(UserContext);

  return (
    <Page {...props}>
      <Grid container spacing={1}>
        <Grid item xs={12}><Typography variant="h4" gutterBottom>Project Colt Home</Typography></Grid>
        <Grid item xs={12}><span>Name: {user?.firstName || 'null'}</span></Grid>
        <Grid item xs={12}><span>Email: {user?.email || 'null'}</span></Grid>
        <Grid item xs={12}><span>Department: {user?.department || 'N/A'}</span></Grid>
        <Grid item xs={12}><span>Roles: <ol>{(user?.roles || []).map((r) => <li key={r.id || r.name}>{r.name}</li>)}</ol></span></Grid>
      </Grid>
    </Page>
  )
}
